import React, { useEffect, useRef, useState } from "react";
import { Github, Linkedin, Mail, Phone } from "lucide-react";

const Contacto = () => {
  const [visible, setVisible] = useState(false);
  const seccionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.15,
      }
    );

    if (seccionRef.current) {
      observer.observe(seccionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const contactos = [
    {
      nombre: "LinkedIn",
      valor: "Mauricio Fernández Licciardi",
      href: "https://www.linkedin.com/in/mauricioferlicc/",
      icono: Linkedin,
      color: "text-[#0077B5]",
    },
    {
      nombre: "GitHub",
      valor: "mauricioferlicc",
      href: "https://github.com/mauricioferlicc",
      icono: Github,
      color: "text-[#1c2143]",
    },
    {
      nombre: "WhatsApp",
      valor: "+54 9 381 551-1470",
      href: "https://wa.me/5493815511470",
      icono: Phone,
      color: "text-[#25D366]",
    },
    {
      nombre: "Email",
      valor: "mauricioferlicc@gmail.com",
      href: "mailto:mauricioferlicc@gmail.com",
      icono: Mail,
      color: "text-[#1c2143]",
    },
  ];

  return (
    <>
      <style>
        {`
          @keyframes aparecerDesdeAbajo {
            from {
              opacity: 0;
              transform: translateY(50px);
            }

            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .contacto-animacion {
            opacity: 0;
          }

          .contacto-visible {
            animation: aparecerDesdeAbajo 0.8s ease-out forwards;
          }

          .contacto-titulo {
            animation-delay: 0.1s;
          }

          .contacto-descripcion {
            animation-delay: 0.3s;
          }

          .contacto-card-1 {
            animation-delay: 0.5s;
          }

          .contacto-card-2 {
            animation-delay: 0.7s;
          }

          .contacto-card-3 {
            animation-delay: 0.9s;
          }

          .contacto-card-4 {
            animation-delay: 1.1s;
          }

          @media (prefers-reduced-motion: reduce) {
            .contacto-animacion {
              opacity: 1;
              animation: none;
            }
          }
        `}
      </style>

      <section
        id="contacto"
        ref={seccionRef}
        className="px-4 py-0 sm:px-6"
      >
        <div className="mx-auto max-w-[1230px]">
          <h2
            className={`contacto-animacion contacto-titulo relative mb-5 text-center text-[35px] font-black text-[#1c2143] sm:text-[50px] ${
              visible ? "contacto-visible" : ""
            }`}
          >
            Contacto

            <span className="mx-auto block h-1 w-[90px] rounded-full bg-[#1c2143] sm:w-[120px]" />
          </h2>

          <p
            className={`contacto-animacion contacto-descripcion mx-auto mb-5 max-w-3xl text-center text-base leading-8 text-black sm:mb-12 ${
              visible ? "contacto-visible" : ""
            }`}
          >
            Si querés contactarme para hablar sobre un proyecto, una propuesta
            laboral o simplemente conocer más sobre mi trabajo, podés hacerlo
            por cualquiera de estos medios.
          </p>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {contactos.map((contacto, index) => {
              const Icono = contacto.icono;

              return (
                <a
                  key={contacto.nombre}
                  href={contacto.href}
                  target={
                    contacto.nombre === "Email" ? undefined : "_blank"
                  }
                  rel={
                    contacto.nombre === "Email" ? undefined : "noreferrer"
                  }
                  className={`group contacto-animacion contacto-card-${
                    index + 1
                  } flex min-h-[70px] flex-col items-center justify-center rounded-[18px] border-2 border-[#1c2143] bg-transparent px-3 py-3 text-center shadow-[0_20px_60px_rgba(28,33,67,0.15)] backdrop-blur-[20px] transition duration-300 hover:-translate-y-1 hover:bg-[#1c2143] hover:shadow-[0_0_40px_rgba(28,33,67,0.25)] sm:min-h-[210px] sm:rounded-[25px] sm:px-5 sm:py-7 ${
                    visible ? "contacto-visible" : ""
                  }`}
                >
                  <div
                    className={`flex h-10 w-10 items-center justify-center rounded-xl bg-[#1c2143]/10 transition duration-300 group-hover:scale-110 group-hover:bg-white/10 sm:h-16 sm:w-16 sm:rounded-2xl ${contacto.color}`}
                  >
                    <Icono size={20} className="sm:hidden" />
                    <Icono size={33} className="hidden sm:block" />
                  </div>

                  <div className="mt-2 sm:mt-5">
                    <p className="text-xl font-bold uppercase tracking-wider text-[#1c2143] transition duration-300 group-hover:text-white sm:text-lg">
                      {contacto.nombre}
                    </p>

                    <p className="mt-1 break-words text-[16px] leading-5 text-black transition duration-300 group-hover:text-white sm:mt-2 sm:text-base sm:leading-6">
                      {contacto.valor}
                    </p>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Contacto;